import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://didrouteapi.com/api';

function LiveCall() {
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [buyerId, setBuyerId] = useState(null);

  const fetchBuyerProfile = async () => {
    try {
      const token = localStorage.getItem('buyerToken');
      const response = await axios.get(`${API_URL}/buyers/dashboard/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setBuyerId(response.data.data.id);
        return response.data.data.id;
      } else {
        throw new Error('Failed to fetch buyer profile');
      }
    } catch (err) {
      setError('Failed to fetch buyer profile');
      return null;
    }
  };

  const fetchCalls = async (currentBuyerId) => {
    try {
      if (!currentBuyerId) return;

      const token = localStorage.getItem('buyerToken');
      const dialogResponse = await axios.get(`${API_URL}/dialogs/buyer/${currentBuyerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if (!dialogResponse.data?.success || !dialogResponse.data?.data?.dialogs) {
        setError('Invalid response format');
        setLoading(false);
        return;
      }

      const transformedData = dialogResponse.data.data.dialogs.map(dialog => ({
        id: dialog.dlg_id,
        Target_Number: dialog.target_number || dialog.mangled_to_uri?.match(/sip:(\d+)@/)?.[1] || "N/A",
        DID_Number: dialog.did_number || dialog.to_uri?.match(/sip:(\d+)@/)?.[1] || "N/A",
        Campaign_Name: dialog.campaign_name || "Unknown Campaign",
        caller_number: dialog.caller_number || dialog.mangled_from_uri?.match(/sip:(\d+)@/)?.[1] || "N/A",
        Status: dialog.status || "Active",
        duration: dialog.duration || 0
      }));

      setCalls(transformedData);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.error || 'Failed to fetch calls');
    }
  };

  useEffect(() => {
    const init = async () => {
      const currentBuyerId = await fetchBuyerProfile();
      if (currentBuyerId) {
        await fetchCalls(currentBuyerId);
      }
    };

    init();

    const intervalId = setInterval(init, 5000);

    return () => clearInterval(intervalId);
  }, []);

  if (loading) {
    return (
      <div className="bg-white p-2 rounded-lg shadow-lg">
        <div className="text-black text-center py-4">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white p-2 rounded-lg shadow-lg">
        <div className="text-red-500 text-center py-4">{error}</div>
      </div>
    );
  }

  return (
    <div className="bg-white p-2 rounded-lg shadow-lg">
      <div className="mx-auto max-w-full">
        <div className="bg-white py-10">
          <div className="px-4 sm:px-4 lg:px-4">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h1 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                  Live Calls
                </h1>
              </div>
            </div>
            <div className="mt-4 flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <table className="min-w-full divide-y divide-gray-700">
                    <thead>
                      <tr>
                        <th className="py-3.5 pl-4 pr-3 text-left text-xs font-medium text-black sm:pl-0">
                          Destination
                        </th>
                        <th className="px-3 py-3.5 text-left text-xs font-medium text-black">
                          DID Number
                        </th>
                        <th className="px-3 py-3.5 text-left text-xs font-medium text-black">
                          Campaign Name
                        </th>
                        <th className="px-3 py-3.5 text-left text-xs font-medium text-black">
                          Caller Number
                        </th>
                        <th className="px-3 py-3.5 text-left text-xs font-medium text-black">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-800">
                      {calls.map((call) => (
                        <tr key={call.id}>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900 pl-0">
                            {call.Target_Number}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {call.DID_Number}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {call.Campaign_Name}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {call.caller_number}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-xs text-gray-900">
                            {call.Status}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveCall;